// process_data runs in an effect even while the loading screen is visible.
// Keep incomplete data in the request cache, not in a render snapshot that
// exposes employees before their schedule/availability can be processed.
export function getRenderableScheduleData(data) {
  const requiredArrays = [
    "store_team_members",
    "actual_schedule",
    "default_availability",
    "all_time_off_requests",
    "role_names",
    "role_types",
    "copilot_schedule",
  ];
  return requiredArrays.every((name) => Array.isArray(data[name]))
    ? data
    : { store_team_members: [] };
}
